module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-600italic.woff?8d513ad94829ef391cd18d4a83bcfc4b";